import React, {ChangeEventHandler} from 'react';
import {FormGroup, Label, Input, InputProps, FormFeedback} from 'reactstrap';

interface Option {
  id: string;
  label: string;
  [key: string]: any;
}

interface SelectProps extends InputProps {
  label: string;
  options: Option[];
  value?: string;
  evento: ChangeEventHandler<HTMLInputElement>;
  error?: string;
  id: string;
  placeholder?: string;
}

const FormSelectInput: React.FC<SelectProps> = ({
  label,
  options,
  value,
  evento,
  error,
  id,
  placeholder,
  ...rest
}) => {
  return (
    <FormGroup>
      <Label for={id}>{label}</Label>
      <Input
        type="select"
        name={id}
        id={id}
        value={value}
        onChange={evento}
        {...rest}
      >
        {placeholder && <option value="">{placeholder}</option>}
        {options.map((option, index) => (
          <option key={option.id} value={option.id}>
            {option.label}
          </option>
        ))}
      </Input>
      {error && <FormFeedback style={{display: 'block'}}>{error}</FormFeedback>}
    </FormGroup>
  );
};

export default FormSelectInput;
